import { PrivateDocumentDto } from '@/shared/lib/sj-orm';

import { FormConfig, PrivateDocFormKeys } from '../types';

export const getSortedItems = (
  formData: FormConfig,
  formKeys: Array<PrivateDocFormKeys>,
  documentData: PrivateDocumentDto,
) => {
  let orderCount = formKeys.length;

  const formItems = formKeys.map((key) => ({
    ...formData[key],
    value: documentData[key],
    formKey: key,
    order: formData[key].order === undefined ? orderCount++ : Number(formData[key].order),
  }));

  return [...formItems].sort((a, b) => a.order - b.order);
};
